import React from 'react';

// TODO scroll link

export function Hero(): React.ReactElement {
  const handleScroll = (e: React.MouseEvent<HTMLAnchorElement>) => {
    const {hash} = e.target as HTMLAnchorElement;
    const content = document.querySelector(hash);
    if (content) {
      e.preventDefault();
      content.scrollIntoView({behavior: 'smooth'});
    }
  };

  return (
    <div className="absolute bottom-20 left-1/2 -translate-x-1/2 text-3xl mix-blend-exclusion">
      <a href="#learn-more" className="underline text-yellow-400" onClick={handleScroll}>
        Scroll down to learn more &darr;
      </a>
    </div>
  );
}
